import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;
const SlotType_URL = `${API_URL}/slot-type`;

const listSlotType = () => {
  return axios.get(`${SlotType_URL}/list`).then((response) => response);
};

const createSlotType = (data: any) => {
  return axios.post(`${SlotType_URL}/add`, data).then((response) => response);
};

const updateSlotType = (data: any, id: any) => {
  return axios.put(`${SlotType_URL}/edit/${id}`, data).then((response) => response);
};

const viewSlotType = (id: any) => {
  return axios.get(`${SlotType_URL}/view/${id}`).then((response) => response);
};

const deleteSlotType = (id: any, userId: number) => {
  return axios.put(`${SlotType_URL}/delete/${id}`, { userId }).then((response) => response);
};

const checkDuplicate = (name: any) => {
  return axios.post(`${SlotType_URL}/duplicate`, { name }).then((response) => response);
};

export {
  listSlotType,
  createSlotType,
  updateSlotType,
  viewSlotType,
  deleteSlotType,
  checkDuplicate,
};
